import styled from "styled-components";

export const Header = styled.div`
  font-size: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
